// Import niezbędnych modułów
import { KeycloakService } from './keycloakService';
import { createAuthAxiosInstance } from './axiosInterceptor';

/**
 * Serwis do zarządzania tokenem autoryzacji
 */
export const AuthService = {
  /**
   * Pobiera token autoryzacji z Keycloak lub z zmiennych środowiskowych jako fallback
   */
  getToken: (): string => {
    const keycloakToken = KeycloakService.getToken();
    return keycloakToken || process.env.REACT_APP_AUTH_TOKEN || '';
  },

  /**
   * Dodaje nagłówek autoryzacji do konfiguracji Axios
   */
  getAuthHeader: () => {
    return {
      'Authorization': `Bearer ${AuthService.getToken()}`
    };
  },

  /**
   * Tworzy instancję Axios z nagłówkiem autoryzacji i interceptorami do odświeżania tokenu
   */
  createAuthenticatedClient: (baseURL: string) => {
    console.log(baseURL)
    return createAuthAxiosInstance(baseURL);
  },

  /**
   * Sprawdza czy użytkownik jest zalogowany
   */
  isAuthenticated: (): boolean => {
    return KeycloakService.isLoggedIn();
  },

  /**
   * Przekierowuje do strony logowania wewnętrznego
   */
  login: (): void => {
    // DODAJ TO:
    // Nie przekierowuj jeśli jesteśmy już na stronie publicznej
    const publicPages = ['/login', '/reset-password-request', '/reset-password'];
    const currentPath = window.location.pathname;
    
    if (publicPages.includes(currentPath)) {
      return; // Nie rób nic, zostań na aktualnej stronie
    }

    // Reszta oryginalnego kodu pozostaje bez zmian...
    const currentLocation = window.location.pathname + window.location.search;
    if (currentLocation !== '/login') {
      sessionStorage.setItem('redirect_after_login', currentLocation);
    }
    // Przekierowanie do wewnętrznej strony logowania zamiast Keycloak
    window.location.href = '/login';
  },


  /**
   * Wylogowuje użytkownika
   */
  logout: (): void => {
    KeycloakService.logout();
  },

  /**
   * Pobiera informacje o zalogowanym użytkowniku
   */
  getUserInfo: () => {
    return KeycloakService.getUserInfo();
  },

  /**
   * Sprawdza czy użytkownik ma określoną rolę
   */
  hasRole: (role: string): boolean => {
    return KeycloakService.hasRole(role);
  }
};
